
import { createNamespacedHelpers } from 'vuex'
import VueCookies from 'vue-cookies'
import { getCurrentCountry  } from '../../../scripts/libs/utils/currentCountry'
import { ACTION_UPDATE_POPUP_CLOSED } from '../../../scripts/store/actions/country-redirect'
import { ACTION_TOGGLE_POPUP_ID } from '../../store/actions/ui'

const { mapActions } = createNamespacedHelpers('countryRedirect')
const { mapActions: mapActionsUi, mapGetters:mapGettersUi } = createNamespacedHelpers('ui')


export default {
  name: 'SghCountryRedirect',
  computed: {
    ...mapGettersUi(['popups']),
    getStoreCountry: () => getCurrentCountry(),
    getUserCountry: () => (VueCookies.get('aka-cc') === 'GB' ? 'UK' : VueCookies.get('aka-cc')),
    isPopupClosedByUser: () => sessionStorage.getItem('GEOPOPUP_CLOSED_BY_USER'),
  },
 mounted() {
    if (this.isGeoredirectPopupVisibile()) {
      this.togglePopup({
        popupId:'geoTargeting',
        open: true,
      })
    }
  },
  methods: {
    ...mapActions({ updatePopupState: ACTION_UPDATE_POPUP_CLOSED }),
    ...mapActionsUi({
      togglePopup: ACTION_TOGGLE_POPUP_ID,
    }),
    isGeoredirectPopupVisibile() {
      return (
        this.getUserCountry &&
        this.getStoreCountry.toLowerCase() !== this.getUserCountry.toLowerCase() &&
        !this.isPopupClosedByUser
      )
    },
    closePopupHandler() {
      sessionStorage.setItem('GEOPOPUP_CLOSED_BY_USER', true)
    },
  },
}
